module.exports = __webpack_public_path__ + "img/03-800x800.1f34f31b.jpg";